import React from 'react';
import { useAuth } from '../../auth';
import { Link } from 'react-router-dom';
import { useRouter } from 'components';

// Member type to title mapping
const memberTypeToTitle = {
  0: "Member",
  1: "Entered Apprentice",
  2: "Fellow Craft", 
  3: "Master Mason",
  18: "Rose Croix",
  30: "Knights Kadosh",
  31: "Tribunal of Courage",
  32: "Consistory",
  33: "Baringa Triangle",
  99: "Admin"
};

export function ProfileView() {
  const auth = useAuth();
  const session = auth.sessionV2 || auth.session || auth.user;
  const router = useRouter();

  if (!session) {
    return (
      <div className="container" style={{maxWidth: '800px', marginInline: 'auto', padding: '2rem'}}>
        <h1>Profile</h1>
        <p>Please log in to view your profile.</p>
        <Link to="/login" className="btn btn-primary">Login</Link>
      </div>
    );
  }

  const memberTypeTitle = memberTypeToTitle[session.memberType] || `Member Type ${session.memberType}`;

  return (
    <div className="container" style={{maxWidth: '800px', marginInline: 'auto'}}>
      <h1>Profile</h1>
      
      <div style={{background: '#f8f9fa', paddingInline: '2rem', paddingBottom: '0.5rem', borderRadius: '8px', border: '1px solid #dee2e6', marginTop: '1rem'}}>
        <h2 style={{marginTop: 0, color: '#495057'}}>Account Information</h2>
        
        <div style={{display: 'grid', gap: '1rem', marginTop: '1rem'}}>
          <div>
            <strong>Email:</strong> {session.email}
            {session.emailVerified && (
              <span style={{color: '#28a745', marginLeft: '0.5rem'}}>✓ Verified</span>
            )}
          </div>
          
          {/* <div>
            <strong>Display Name:</strong> {session.displayName || 'Not set'}
          </div> */}
          
          <div>
            <strong>Member:</strong> {memberTypeTitle}
          </div>
          
          {session.roles && session.roles.length > 0 && (
            <div>
              <strong>Admin Roles:</strong> {session.roles.join(', ')}
            </div>
          )}
          
          <div>
            <strong>Account Status:</strong> {session.uid ? 'Active' : 'Not available'}
          </div>
        </div>
      </div>

      <div style={{marginTop: '2rem', paddingInline: '2rem', paddingBottom: '0.5rem', background: '#e7f3ff', borderRadius: '8px', border: '1px solid #b3d9ff'}}>
        <h3 style={{marginTop: 0, marginBottom: '0.5rem', color: '#004085'}}>Quick Actions</h3>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
          <Link 
            to="/dashboard" 
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#c2a56b',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '0.9rem'
            }}
          >
            Back to Dashboard
          </Link>
          <Link 
            to="/" 
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#6c757d',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '0.9rem'
            }}
          >
            Back to Home
          </Link>
          <button 
            onClick={() => auth.signoutAdmin().then(() => {
              router.push('/login');
            }).catch(() => {
              router.push('/login');
            })}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.9rem',
              cursor: 'pointer'
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
} 